import vector from '../img/animation.svg';
import s from './questions.module.scss';

export default function Questions() {

    return (
        <div className={s.container}>
            <h1 className={s.qs_01} data-aos='fade-right'>
                Most likely, you have come here to know, what this is?
                <img className={s.vector} src={vector} alt="" />
            </h1>
            <h1 className={s.qs_02} data-aos='fade-left'>
                And why I am cluttering up your timeline?
            </h1>
            <h1 className={s.qs_03} data-aos='fade-right'>
                Telling me that "we do have calenders".
            </h1>
        </div>

    )
}

